import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../PrimaryButton';
import ConfirmPopup from '../ConfirmPopup';
import AnnouncePopup from '../AnnouncePopup';
import AnnounceIcon from '../../../public/assets/images/icons/megaphone.svg';
import DeleteIcon from '../../icons/white-trash.svg';

import { LoopFooterSection, BottomPanel, DeleteButton, AnnounceButton, Wrapper } from './styles';

const FooterSection = ({
  options,
  remove,
  flash,
  data,
  save,
  translations,
  showSaveButton,
  isCollaborator,
  isSession,
  isOwner,
}) => {
  const { userToken, circle_id } = options;

  const [confirmPopupIsOpen, setConfirmPopupIsOpen] = useState(false);
  const [announcePopupIsOpen, setAnnouncePopupIsOpen] = useState(false);

  const toggleAnnouncePopup = () => {
    setAnnouncePopupIsOpen(!announcePopupIsOpen);
  };

  const removeLoop = () => {
    setConfirmPopupIsOpen(!confirmPopupIsOpen);
    remove();
  };

  const appTexts = translations.app;

  return (
    <LoopFooterSection>
      <BottomPanel>
        <Wrapper>
          {isSession ? (
            <AnnounceButton
              src={AnnounceIcon}
              title={i18n.__('app_announce_explaination')}
              onClick={toggleAnnouncePopup}
            >
              {i18n.__('app_announce')}
            </AnnounceButton>
          ) : (
            (isOwner || isCollaborator) && (
              <DeleteButton src={DeleteIcon} title={appTexts.remove_circle} onClick={() => setConfirmPopupIsOpen(true)}>
                {appTexts.remove_circle}
              </DeleteButton>
            )
          )}
        </Wrapper>
        {showSaveButton && (
          <Wrapper>
            <PrimaryButton onClick={save} text={i18n.__('app_save')} className="save-button" />
          </Wrapper>
        )}
      </BottomPanel>
      <ConfirmPopup
        popupIsOpen={confirmPopupIsOpen}
        id="confirmRemoveLoop"
        title={`${i18n.__('delete_loop')} '${data.name}'`}
        message={i18n.__('delete_confirm')}
        onCancel={() => setConfirmPopupIsOpen(false)}
        onConfirm={removeLoop}
      />
      <AnnouncePopup
        userToken={userToken}
        loopId={circle_id}
        popupIsOpen={announcePopupIsOpen}
        onClose={() => setAnnouncePopupIsOpen(false)}
        flash={flash}
      />
    </LoopFooterSection>
  );
};

export default FooterSection;

FooterSection.propTypes = {
  options: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired,
  flash: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  showSaveButton: PropTypes.bool.isRequired,
  isCollaborator: PropTypes.bool.isRequired,
  isSession: PropTypes.bool.isRequired,
  isOwner: PropTypes.bool.isRequired,
};
